import { render, staticRenderFns } from "./columnSettingsDialog.vue?vue&type=template&id=4e383783&scoped=true&"
import script from "./columnSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./columnSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./columnSettingsDialog.vue?vue&type=style&index=0&id=4e383783&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e383783",
  null
  
)

export default component.exports